import type { HttpTransport } from "@common/api/transport";
import type { ActiveSubscriptionInfo } from "@common/types";
import type { CancellationSaver } from "@common/types/Subscription";

export const createSubscriptionApi = (http: HttpTransport) => ({
  downgradeToFreeSubscription: () =>
    fetch("/api/active_subscription/downgrade_to_free", { method: "PATCH" }),

  fetchActiveSubscription: () =>
    http.get<ActiveSubscriptionInfo>("/api/active_subscription"),

  fetchPaykickstartBillingSession: () =>
    http.post<{ iframeUrl: string; scriptUrl: string }>(
      "/api/paykickstart/billing_session",
      {}
    ),

  fetchPaykickstartCancellationSaver: () =>
    http.post<CancellationSaver>("/api/paykickstart/cancellation_saver", {})
});
